import { TextField } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { Controller } from 'react-hook-form';
import { handleEnterAsTab } from '../../../utils/handleEnterAsTab';
import { UserPrefix } from '../AccidenCreatingStepCustomerInformations';

/** Titul + Jméno + Příjmení */
export const PersonFields = ({
  prefix,
  control
}: {
  prefix: UserPrefix;
  control: any;
}) => (
  <>
    <Grid container spacing={2}>
      <Grid size={3}>
        <Controller
          control={control}
          name={`${prefix}.degree`}
          render={({ field }) => (
            <TextField
              {...field}
              value={field.value ?? ''}
              label="Titul"
              color="secondary"
              fullWidth
              InputLabelProps={{ shrink: true }}
              onKeyDown={handleEnterAsTab}
            />
          )}
        />
      </Grid>
      <Grid size={9}>
        <Controller
          control={control}
          name={`${prefix}.name`}
          render={({ field }) => (
            <TextField
              {...field}
              value={field.value ?? ''}
              label="Jméno"
              color="secondary"
              fullWidth
              required
              InputLabelProps={{ shrink: true }}
              onKeyDown={handleEnterAsTab}
            />
          )}
        />
      </Grid>
    </Grid>
    <Controller
      control={control}
      name={`${prefix}.surname`}
      render={({ field }) => (
        <TextField
          {...field}
          value={field.value ?? ''}
          label="Příjmení"
          color="secondary"
          fullWidth
          required
          InputLabelProps={{ shrink: true }}
          onKeyDown={handleEnterAsTab}
        />
      )}
    />
  </>
);
